import { Component, OnInit, Input } from '@angular/core';
import { GenericResponse } from 'src/app/data/repository/generic-response';
import { TextHelper } from 'src/app/utils/text-helper';
import { UserApiService } from 'src/app/data/repository/user-repository/user-api.service';
import { WeightLogService } from 'src/app/data/repository/plan-repository/weight-log.service';
import { Weightlog } from 'src/app/core/model/api-response/weight-log-response-model';
import { DateHelper } from 'src/app/utils/date-helper';

@Component({
  selector: 'app-edit-weight',
  templateUrl: './edit-weight.component.html',
  styleUrls: ['./edit-weight.component.scss'],
})
export class EditWeightComponent implements OnInit {
  @Input() weightlog: Weightlog;

  fractionalWeight: string;
  decimalWeight: string;
  secondInputText = '';
  hasError = false;

  constructor(
    private textHelper: TextHelper,
    private userApiService: UserApiService,
    private weightLogService: WeightLogService,
    private dateHelper: DateHelper
  ) {}

  ngOnInit() {
    const weight = this.weightlog.weight;
    this.fractionalWeight = Math.round(
      (weight - Math.floor(weight)) * 10
    ).toString();
    this.decimalWeight = Math.floor(weight).toString();
    this.checkActivatingButton(1);
  }

  save(): Promise<GenericResponse> {
    let response: GenericResponse;
    this.decimalWeight = this.textHelper.replacePersian(this.decimalWeight);
    this.fractionalWeight = this.textHelper.replacePersian(
      this.fractionalWeight
    );
    if (!this.hasErrors()) {
      const dec = parseInt(this.decimalWeight);
      const frac = parseInt(this.fractionalWeight);
      const weight = (dec * 10 + frac) / 10;
      // console.log('saved', weight)
      let today = new Date();
      today = new Date(today.setHours(0, 0, 0, 1));
      if (
        this.dateHelper.isSameDay(today, new Date(this.weightlog.date)) &&
        this.weightlog._id !== '-'
      ) {
        return this.weightLogService
          .updateWeight(weight, this.weightlog._id)
          .then((res) => {
            if (res.isSuccess()) {
              // return this.userApiService.editUser(null, null, null, weight, null);
              response = new GenericResponse(true);
              return Promise.resolve(response);
            } else {
              response = new GenericResponse(false);
              return Promise.resolve(response);
            }
          });
      } else {
        return this.weightLogService
          .addWeight(today.getTime(), weight)
          .then((res) => {
            if (res.isSuccess()) {
              return this.userApiService.editUser(
                null,
                null,
                null,
                weight,
                null
              );
            } else {
              response = new GenericResponse(false);
              return Promise.resolve(response);
            }
          });
      }
    } else {
      response = new GenericResponse(false);
      return Promise.resolve(response);
    }
  }

  checkActivatingButton(index: number) {
    this.hasError = false;
    if (index === 0 && this.decimalWeight.length === 3) {
      document.getElementById('input' + index).blur();
      document.getElementById('input' + (index + 1)).focus();
    } else {
      if (this.fractionalWeight && this.fractionalWeight.length !== 0) {
        this.secondInputText = this.fractionalWeight;
      }
    }
  }

  keytab(event, index: number) {
    this.hasError = false;
    if (
      event.key === 'Backspace' &&
      (!this.fractionalWeight || this.fractionalWeight === '')
    ) {
      if (index === 1 && this.fractionalWeight !== this.secondInputText) {
        this.secondInputText = this.fractionalWeight;
        return;
      }
      document.getElementById('input' + index).blur();
      document.getElementById('input' + (index - 1)).focus();
      this.decimalWeight = '';
    }
  }

  hasErrors() {
    if (this.decimalWeight === '' || this.fractionalWeight === '') {
      this.hasError = true;
      return true;
    }
    if (
      parseInt(this.decimalWeight) < 30 ||
      parseInt(this.decimalWeight) > 300
    ) {
      this.hasError = true;
      return true;
    }
    return false;
  }
}
